module.exports = __webpack_public_path__ + "img/0483a45.webp";